import createMuiTheme from '@material-ui/core/styles/createMuiTheme'

const primaryColor = 'rgb(89,32,99)'
const secondaryColor = 'rgb(0,92,89)'
export const consumerCheckoutPageTheme = createMuiTheme({
    palette: {
        background: {
            default: '#FFFFFF',
        },
        primary: {
            main: primaryColor,
        },
        secondary: {
            main: secondaryColor,
        },
        black: {
            main: '#222222',
        },
        grey: {
            main: '#F8F8F8',
            secondary: '#747474',
        },
    },
    typography: {
        h1: {
            margin: '0.5rem 0',
            fontSize: '2rem',
            fontWeight: 'bold',
        },
        h2: {
            margin: '0 0 1.5rem 0',
            fontSize: '1.5rem',
            fontWeight: 'bold',
        },
        body1: {
            fontSize: '1.1rem',
        },
    },
})

export const rootStyles = {
    root: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '80vh',
        backgroundColor: '#FFFFFF',
        '& img': {
            display: 'block',
            maxWidth: '100%',
        },
    },
}
